import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { ProfileOwnerWatchButton } from '../../../../../../Button';
import s from './ThumbPaywall.scss';
var WatchersOnlyThumbPaywall = function (_a) {
    var deviation = _a.deviation, isSmall = _a.isSmall, className = _a.className;
    var t = useTranslation().t;
    return (React.createElement("div", { className: classnames(s['root'], isSmall && s['small'], className) },
        React.createElement("div", { className: s['label'] }, t('deviationview.overlay.premiumFolder.unlockHint.watch')),
        deviation.author && (React.createElement(ProfileOwnerWatchButton, { className: s['button'], user: deviation.author, onToggleWatchSuccess: function () {
                window.location.href = deviation.url;
            } }))));
};
WatchersOnlyThumbPaywall.displayName = 'WatchersOnlyThumbPaywall';
export default WatchersOnlyThumbPaywall;
//# sourceMappingURL=WatchersOnlyPaywall.js.map